<template>
  <MinutesContainer />
</template>

<script lang="ts">
import Vue from "vue";
import MinutesContainer from "@/components/projects/project/minutes/container/MinutesContainer.vue";

export default Vue.extend({
  components: {
    MinutesContainer,
  },
});
</script>
